import { StepType } from '../../../interfaces/enums/step-type';
import store from '@/store';
import BaseStep from './BaseStep';
import IAction from '@/interfaces/actions.interface';

export default class DiscoverStep extends BaseStep {
	public stepType = StepType.DISCOVER;
	public actions: IAction[] = [
		{
			done: (): boolean => {
				const disciplineInterests = store.getters.disciplinesOfInterest();
				const countryInterests = store.getters.countriesOfInterest();
				const nationalityCountry = store.getters.nationalityCountry();
				const startDate = store.getters.startDate();

				if (
					disciplineInterests.length > 0 &&
					countryInterests.length > 0 &&
					nationalityCountry !== '' &&
					startDate !== ''
				) {
					return true;
				}

				return false;
			},
		},
		{
			done: (): boolean => {
				return store.getters.getWishlistStudyCount() > 0;
			},
		},
	];

	public icon = 'lnr-compass2';
	public heading = 'Discover';
	public description = 'Find and save all potentially interesting programmes.';
	public readyToCompleteText = 'If you have saved all programmes you like, press below to mark this step as complete';
}
